import { Box } from '@mui/material';
import { AddMerchantApplicationPayload } from 'types/graphql';

import { isIreland } from 'src/lib/countryConfig';
import { SupportingDocuments } from 'src/pages/AddMerchantPage/steps/SupportingDocuments';

import DocumentUploadHelpBanner from '../DocumentUploadHelpBanner';

interface SupportingDocumentsContentProps {
    isUploadingDocuments: boolean;
    merchantApplication: AddMerchantApplicationPayload;
    onCancel: () => void;
    setDocumentsSubmitState?: (value: boolean) => void;
}

const SupportingDocumentsContent = ({
    isUploadingDocuments,
    merchantApplication,
    onCancel,
    setDocumentsSubmitState,
}: SupportingDocumentsContentProps) => {
    return (
        <Box sx={{ p: 2 }}>
            {isIreland && (
                <Box sx={{ mb: 2 }}>
                    <DocumentUploadHelpBanner
                        businessType={
                            merchantApplication?.merchantInformation?.aboutBusiness?.businessType
                        }
                    />
                </Box>
            )}
            <SupportingDocuments
                setDocumentsSubmitState={setDocumentsSubmitState}
                isUploadingDocuments={isUploadingDocuments}
                application={merchantApplication}
                onBack={onCancel}
                key="supporting-documents"
            />
        </Box>
    );
};

export default SupportingDocumentsContent;
